import React, {ComponentProps, FC} from 'react';

import {EventHandler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {DateTimeFormatter} from '../../../../../srcCommon/formatters/dateTime/dateTimeFormatter';

/*
 * Props.
 */

interface InteractiveDateTimeFormatterProps extends ComponentProps<typeof DateTimeFormatter> {
  onClick: EventHandler;
  shouldDisableFormatToggling?: boolean;
  className?: string;
}

/*
 * Component.
 */

export const InteractiveDateTimeFormatter: FC<InteractiveDateTimeFormatterProps> = (props) => (
  <ChromelessButton
    onClick={props.shouldDisableFormatToggling ? undefined : props.onClick}
    className={props.className}
  >
    <DateTimeFormatter value={props.value} format={props.format} relativeFormat={props.relativeFormat} />
  </ChromelessButton>
);
